import script from "./PrefabWallViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PrefabWallViewer.vue?vue&type=script&setup=true&lang=js"

import "./PrefabWallViewer.vue?vue&type=style&index=0&id=15f5747b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f5747b"]])

export default __exports__